import en from "./src/lang/en-US.json";
import fr from "./src/lang/fr.json";
import dyu from "./src/lang/dyu.json";
import wo from "./src/lang/wo.json";
import mg from "./src/lang/mg.json";
import ba from "./src/lang/ba.json";
import { IntlProvider } from "react-intl";
import { useAppSelector } from "@/lib/store/hooks";
import React from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const messages: any = {
  en,
  fr,
  dyu,
  wo,
  mg,
  ba,
};

interface Props {
  children: React.ReactNode;
}

export default function IntlProviderMain({ children }: Props) {
  const lang = useAppSelector((state) => state.lang.lang);
  return (
    <IntlProvider
      defaultLocale="fr"
      messages={messages[lang]}
      locale={lang === "dyu" ? "fr" : lang} // Fallback to French for number formatting
    >
      {children}
    </IntlProvider>
  );
}
